/* Native product forms and details remain functional without JavaScript. */
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-fu-ro]').forEach((root) => {
      if (root.dataset.fuInitialized) return;
      root.dataset.fuInitialized = 'true';
      const grid = root.querySelector('[data-fu-catalogue]');
      const bar = root.querySelector('[data-fu-mobile-shop]');
      if (grid && bar && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting; }, { threshold: 0 });
        observer.observe(grid);
        root.fuCleanup = () => observer.disconnect();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fu-ro]').forEach((root) => root.fuCleanup?.());
  });
})();